import { useNavigation as useNav, useRoute as useRt } from '@react-navigation/native'

export const useSafeNavigation = () => {
  try {
    return useNav()
  } catch {
    return null
  }
}

export const useSafeRoute = () => {
  try {
    return useRt()
  } catch {
    return null
  }
}
